import { TFunction } from "i18next";

import { normalizeText } from "../../edit_account.utils";

type Value = {
  id: string;
  text: string;
  displayElement?: string;
  locked?: boolean;
};

type TransformAllowedLanguages = {
  input: (locales: string[], t: TFunction) => Value[];
  output: (locales: Value[]) => string[];
  formatOption: (locale: string, t: TFunction) => Value;
  query: (rawTerm: string, availableLocales: string[]) => Promise<string[]>;
};

export const transform: TransformAllowedLanguages = {
  input: (locales, t) =>
    locales.map((locale) => ({
      id: locale,
      text: t(`${locale}`),
      locked: locale === "en"
    })),
  output: (locales) => locales.map(({ id }) => id),
  formatOption: (locale, t) => ({
    id: locale,
    text: t(`${locale}`),
    displayElement: t(`${locale}`),
    item: {
      id: locale,
      text: t(`${locale}`),
      displayElement: t(`${locale}`)
    }
  }),
  query: (rawTerm, availableLocales) => {
    const term = normalizeText(rawTerm);
    return Promise.resolve(availableLocales.filter((text) => normalizeText(text).includes(term)));
  }
};
